var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18 9A9 9 0 1 1 0 9a9 9 0 0 1 18 0zM9.323 6.644c-.876.364-2.625 1.118-5.25 2.261-.425.17-.648.335-.669.497-.034.274.309.382.776.529l.197.062c.46.15 1.078.325 1.399.332.291.006.617-.114.976-.361 2.451-1.655 3.717-2.491 3.796-2.51.056-.012.134-.028.187.019.052.047.047.135.042.159-.034.145-1.38 1.397-2.078 2.044-.217.202-.37.345-.402.378-.071.073-.143.143-.212.21-.427.411-.747.72.018 1.224.367.242.661.442.955.642.32.218.64.436 1.053.707.106.069.206.14.304.21.373.266.708.505 1.122.467.24-.022.489-.248.615-.923.298-1.594.884-5.047 1.02-6.47.012-.125-.003-.285-.015-.355s-.037-.17-.128-.243a.592.592 0 0 0-.35-.105c-.338.006-.857.187-3.356 1.226z",
    fill: "currentColor",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.6f5165fbae96082bd529e448438840f6.svg";
export { ForwardRef as ReactComponent };